import Vue from 'vue';

export default {
    methods: {
        async getIndicadores(ok, err) {
            try {
                let r = await Vue.axios.post('indicadores/listado')
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async getIndicadoresGrupos(ok, err) {
            try {
                let r = await Vue.axios.post('indicadores/grupos')
                ok(r.data)
            } catch (e) {
                err(e)
            }
        }
    }

}


// WEBPACK FOOTER //
// ./resources/assets/js/mixins/indicadores.js